import {
  queryVehicleBrand,
  queryVehicleList,
  queryBrandList,
  queryK2ProductList,
  updateProduct,
  queryBrandOrgManagementPage,
  createBrandOrgManagement,
  updateBrandOrgManagement,
  updateBrandOrgManagementState,
  queryPriceActivity,
  createPriceActivity,
  updatePriceActivity,
  deletePriceActivity,
  ChangeActivityStatus,
  queryActivitySku,
  priceActivitySalePriceManagement,
  checkPriceActivity,
  exportSalePrice,
  queryOrganizationByLevel,
  queryBaseShopPage,
  queryBaseStorePage,
  queryActivityTagManage,
  queryOrganizationList,
  queryGtProductListSimple,
  exportAllProductCode,
  downLoadProductTemplate,
  getSystemTags,
  getK1TagManageBaseList
} from "@/graphql/wt.gql";
// TODO: 分隔模块
import { resRest } from "@root/lib/utils";
export default {
  namespaced: true,
  state: {
    brand: "",
    cacheDataList: []
  },
  getters: {
    cacheDataListCodes(state) {
      return state.cacheDataList.map(({ productCode }) => productCode);
    }
  },
  actions: {
    // 根据层级查询K1,K2
    async queryOrganizationByLevel({ rootState }, options) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryOrganizationByLevel,
        variables: options
      });
      return { list: resRest(data), total };
    },
    // K1
    async queryOrganizationByLevel2({ rootState, dispatch }, options) {
      return await dispatch("queryOrganizationByLevel", {
        // orgParent: "default", // 不需要传orgParent，账号不匹配会抛错
        orgLevel: 1,
        ...options
      });
    },
    // K2
    // async queryOrganizationByLevel3({ rootState, dispatch }, options) {
    //   return await dispatch("queryOrganizationByLevel", {
    //     // orgParent: "default",
    //     orgLevel: 2,
    //     ...options
    //   });
    // },
    async queryOrganizationByLevel3({ dispatch }, variables) {
      const { searchKey = "", pageInput: { pageNum = 1, pageSize = 10 } = {} } =
        variables || {};
      return await dispatch("queryOrganizationByLevel", {
        orgCode: searchKey,
        orgName: searchKey,
        orgParent: "root",
        orgLevel: 2, // K2 --->  orgLevel :2
        pageInput: {
          pageNum,
          pageSize
        }
      });
    },
    async queryBaseShopPage({ rootState }, options) {
      const { searchKey = "", pageInput: { pageNum = 1, pageSize = 10 } = {} } =
        options || {};
      const {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryBaseShopPage,
        variables: {
          searchKey,
          pageInput: {
            pageNum,
            pageSize
          }
        }
      });
      return { list: resRest(data), total };
    },
    async queryBaseStorePage({ rootState }, options) {
      const { searchKey = "", pageInput: { pageNum = 1, pageSize = 10 } = {} } =
        options || {};
      const {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryBaseStorePage,
        variables: {
          searchKey,
          pageInput: {
            pageNum,
            pageSize
          }
        }
      });
      return { list: resRest(data), total };
    },
    async getVehicleBrand({ rootState }, data) {
      let res = await rootState.gql.query({
        query: queryVehicleBrand,
        variables: {
          request: {
            vehicleType: "1"
          }
        }
      });
      return res.data.dataList;
    },
    async getWtPrice({ rootState }, options) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryVehicleList,
        variables: {
          request: {
            vehicleType: Math.random() * 10 > 5 ? "1" : "222",
            orderStr: "CREATE_TIME DESC"
          },
          options
        }
      });
      return { data: resRest(data), total };
    },
    async getWtPriceRule({ rootState }, options) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryVehicleList,
        variables: {
          request: {
            vehicleType: Math.random() * 10 > 5 ? "1" : "222",
            orderStr: "CREATE_TIME DESC"
          },
          options
        }
      });
      return { data: resRest(data), total };
    },
    async getWtDealer({ rootState }, options) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryVehicleList,
        variables: {
          request: {
            vehicleType: Math.random() * 10 > 5 ? "1" : "222",
            orderStr: "CREATE_TIME DESC"
          },
          options
        }
      });
      return { data: resRest(data), total };
    },
    // 获取品牌的下拉
    async queryBrandList({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: queryBrandList,
        variables: data
      });
      let result = {
        list: resRest(res.data) || [],
        total: res.data.api.pageInfo.totalCount
      };
      return result;
    },
    async checkPriceActivity({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: checkPriceActivity,
        variables: {
          input: data
        }
      });
      let result = {
        list: res.data.api || [],
        total: res.data.api.length
      };
      return result;
    },
    async queryK2ProductList({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: queryK2ProductList,
        variables: data
      });
      let result = {
        list: resRest(res.data) || [],
        total: res.data.api.pageInfo.totalCount
      };
      return result;
    },
    async updateProduct({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: updateProduct,
        variables: {
          input: {
            ...data
          }
        }
      });
    },
    // k1品牌授权
    async queryBrandOrgManagementPage(
      { commit, state, rootState }: any,
      data?: any
    ) {
      const res = await rootState.gql.query({
        query: queryBrandOrgManagementPage,
        variables: data
      });
      let result = {
        list: resRest(res.data) || [],
        total: res.data.api.pageInfo.totalCount
      };
      return result;
    },
    async createBrandOrgManagement(
      { commit, state, rootState }: any,
      data?: any
    ) {
      await rootState.gql.mutate({
        mutation: createBrandOrgManagement,
        variables: {
          input: {
            ...data
          }
        }
      });
    },
    async updateBrandOrgManagement(
      { commit, state, rootState }: any,
      data?: any
    ) {
      await rootState.gql.mutate({
        mutation: updateBrandOrgManagement,
        variables: {
          input: {
            ...data
          }
        }
      });
    },
    async updateBrandOrgManagementState(
      { commit, state, rootState }: any,
      data?: any
    ) {
      await rootState.gql.mutate({
        mutation: updateBrandOrgManagementState,
        variables: {
          ...data
        }
      });
    },
    // 更新活动列表页
    async queryPriceActivity({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: queryPriceActivity,
        variables: data
      });
      let result = {
        list: resRest(res.data) || [],
        total: res.data.api.pageInfo.totalCount
      };
      return result;
    },
    // 查询表格里内容
    async queryActivitySku({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: queryActivitySku,
        variables: data
      });
      let result = {
        list: resRest(res.data) || [],
        total: res.data.api.pageInfo.totalCount
      };
      return result;
    },
    async createPriceActivity({ commit, state, rootState }: any, data?: any) {
      return await rootState.gql.mutate({
        mutation: createPriceActivity,
        variables: {
          input: data
        }
      });
    },
    async updatePriceActivity({ commit, state, rootState }: any, data?: any) {
      return await rootState.gql.mutate({
        mutation: updatePriceActivity,
        variables: {
          input: data
        }
      });
    },
    async deletePriceActivity({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: deletePriceActivity,
        variables: {
          input: data
        }
      });
    },
    async changeActivityStatus({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: ChangeActivityStatus,
        variables: data
      });
    },
    // 商品价格管理
    async priceActivitySalePriceManagement(
      { commit, state, rootState }: any,
      data?: any
    ) {
      const res = await rootState.gql.query({
        query: priceActivitySalePriceManagement,
        variables: data
      });
      let result = {
        list: resRest(res.data) || [],
        total: res.data.api.pageInfo.totalCount
      };
      return result;
    },
    // 更新活动列表页
    async queryOrganizationList({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: queryOrganizationList,
        variables: data
      });
      let result = {
        list: resRest(res.data) || [],
        total: res.data.api.pageInfo.totalCount
      };
      return result;
    },
    async exportSalePrice({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: exportSalePrice,
        variables: data
      });
      return res;
    },
    async queryActivityTagManage({ rootState }, options) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryActivityTagManage,
        variables: options
      });
      return { data: resRest(data), total };
    },
    async queryGtProductListSimple({ rootState }, { pageInput, condition }) {
      const {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryGtProductListSimple,
        variables: {
          condition,
          pageInput
        }
      });

      return {
        dataList: resRest(data),
        total
      };
    },

    async getSystemTags({ commit, state, rootState }: any, variables?: any) {
      return await rootState.gql.query({
        query: getSystemTags,
        variables
      });
    },
    async getK1TagManageBaseList(
      { commit, state, rootState }: any,
      variables?: any
    ) {
      return await rootState.gql.query({
        query: getK1TagManageBaseList,
        variables
      });
    },
    async downLoadProductTemplate(
      { commit, state, rootState }: any,
      data?: any
    ) {
      const res = await rootState.gql.query({
        query: downLoadProductTemplate,
        variables: data
      });
      return res;
    },
    async exportAllProductCode({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: exportAllProductCode,
        variables: data
      });
      return res;
    }
  },
  mutations: {
    addCacheDataList(state, { dataList, getters }) {
      // 去重
      const hadCodes = state.cacheDataList.map(
        ({ productCode }) => productCode
      );
      dataList &&
        dataList.forEach(el => {
          const deExist = !hadCodes.includes(el && el.productCode);
          if (deExist) {
            state.cacheDataList.push(el);
          }
        });
    },
    updateCacheDataList(state, { row, status = false, isFlag = false }) {
      // 更新
      if (!row) return;
      const { productCode: childProductCode } = row;
      state.cacheDataList &&
        state.cacheDataList.forEach(row => {
          const { productCode } = row;
          if (productCode === childProductCode) {
            row.hasSelected = status;
            row.isRowSelected = isFlag;
          }
        });
    },
    clearCacheDataList(state) {
      state.cacheDataList = [];
    }
  }
};
